<template>
  <section class="f-search">
    <input 
    type="search"
    name="search"
    :value="computedValue"
    @input="$emit('input', $event.target.value)">
    <button class="search" tabindex="-1"><ab-icon icon="search"></ab-icon></button>
  </section>
</template>

<script>
  import AbIcon from '@/components/icon/ab-icon.vue';

  export default {
    name: "f-search",
    components: {
      AbIcon
    },
    props: {
      value: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        inputValue: this.value,
      }
    },
    computed: {
      computedValue() {
        return this.inputValue
      },
    },
    watch: {
      value(value) {
        this.inputValue = value
      }
    },
  }
</script>

<style scoped>
  .f-search {
    position: relative;
    height: 2.1rem;
  }
  input {
    border: none;
    border-radius: 5px;
    height: 100%;
    width: 100%;
    padding: 0 2.1rem 0 0.54rem;
  }
  .search {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.1rem;
    padding: 0;
    text-align: center;
    border-radius: 0 5px 5px 0;
    border: none;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    color: var(--app-white-color);
    background-color: var(--app-primary-color);
  }
  input:focus, .search:focus {
    outline: none;
  }
</style>